module.exports = __webpack_public_path__ + "src/assets/img/ic15.f956a62e.svg";